import { clearInlineError, flashLabel, flashNote, showInlineError } from 'components/inlineFeedback';

$(function(){
	let authenticateCodeCopy = $('#authenticate_code_copy');
	if(authenticateCodeCopy.length)
	{
		authenticateCodeCopy.on('click', '.make_visible', function(e){
			authenticateCodeCopy.find('.copy_code_display').addClass('showing_code');
		});
		authenticateCodeCopy.on('click', '.copy_to_clipboard', function(e){
			let clickedButton = this;
			let code = authenticateCodeCopy.find('.copy_code');
			copyToClipboard(code.val(), function(){
				flashLabel(clickedButton, '✓ Copied');
			});
		});
	}

	let authorizeClientForms = $('#authorize_client_forms');

	if(authorizeClientForms.length)
	{
		authorizeClientForms.on('click', '.client_form .delete', function(e){
			e.preventDefault();
			let data = {};
			let removeDelete = confirm('Delete?');
			if(!removeDelete)
			{
				return;
			}
			data.delete_client = $(this).data('client_id');
			$.post('', data, function(){
				window.location.reload();
			});
		});
	}

	let authorizeLinksEdit = $('#authorize_links_edit');
	if(authorizeLinksEdit)
	{
		authorizeLinksEdit.on('change', '.link_active_checkbox', function(e){
			let checkbox = $(this);
			let form = $(this).closest('form').submit();

		}).on('submit', '.link_active_form', function(e){
			e.preventDefault();
			let form = this;
			let data = $(form).serializeArray();
			clearInlineError(form);
			$.post($(form).data('action'), data).then(function(){
				flashNote(form, '✓ Saved');
			}, ()=>{
				showInlineError(form, 'The link could not be saved.');
			});
		}).on('change', '.smashladder_authentication_link', function(e){
			let clicked = $(this);
			let form = clicked.closest('form');
			let data = {};
			clearInlineError(form);
			if(clicked.is(':checked'))
			{
				data.link_id = clicked.data('link_id');
			}
			else
			{
			}
			$.post(form.attr('action'), data).then(function(){
				let authenticationLinks = $('.smashladder_authentication_link').not(clicked);
				if(clicked.is(':checked'))
				{
					authenticationLinks.prop('checked', false);
				}
				else
				{

				}
				flashNote(form, '✓ Saved');
			}, ()=>{
				showInlineError(form, 'The link could not be saved.');
			});
		});
	}


});